"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-client-list"
  }, [_c("div", {
    staticClass: "filters-toolbar"
  }, [_c("div", {
    staticClass: "filters-toolbar__header"
  }, [_c("h1", {
    staticClass: "title-page"
  }, [_vm._v("Prova de Vida")]), _vm._v(" "), _c("b-button", {
    staticClass: "is-primary filters-toolbar__primary-action",
    on: {
      click: _vm.openModalNew
    }
  }, [_vm._v("\n        Gerar Nova Validação\n      ")])], 1), _vm._v(" "), _c("div", {
    staticClass: "filters-toolbar__content"
  }, [_c("div", {
    staticClass: "filters-toolbar__search-row"
  }, [_c("div", {
    staticClass: "filter-slot filter-slot--input"
  }, [_c("app-input", {
    attrs: {
      "class-field": "mb-0",
      placeholder: "Pesquise pelo CPF",
      mask: ["###.###.###-##"],
      error: _vm.$v.form.document.$error
    },
    on: {
      "update:error": function updateError($event) {
        return _vm.$set(_vm.$v.form.document, "$error", $event);
      }
    },
    model: {
      value: _vm.$v.form.document.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.document, "$model", $$v);
      },
      expression: "$v.form.document.$model"
    }
  })], 1), _vm._v(" "), _c("div", {
    staticClass: "filter-slot filter-slot--input"
  }, [_c("app-input", {
    attrs: {
      "class-field": "mb-0",
      placeholder: "Pesquise pelo Hive ID"
    },
    model: {
      value: _vm.form.hiveId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "hiveId", $$v);
      },
      expression: "form.hiveId"
    }
  })], 1), _vm._v(" "), _c("div", {
    staticClass: "filter-slot filter-slot--button"
  }, [_c("b-button", {
    staticClass: "is-info filter-slot__action",
    on: {
      click: _vm.handleSearchDocument
    }
  }, [_vm._v("\n            Pesquisar\n          ")])], 1)]), _vm._v(" "), _c("div", {
    staticClass: "filters-toolbar__secondary-row"
  }, [_c("app-select", {
    attrs: {
      "class-field": "mb-0 filter-slot filter-slot--select",
      label: "Filtrar por Status",
      placeholder: "Selecione o status que deseja filtar",
      items: _vm.listStatusOptions,
      option: "id",
      "name-item": "name"
    },
    model: {
      value: _vm.filterStatus,
      callback: function callback($$v) {
        _vm.filterStatus = $$v;
      },
      expression: "filterStatus"
    }
  }), _vm._v(" "), _vm.isAdmin ? [_c("app-select", {
    attrs: {
      "class-field": "mb-0 filter-slot filter-slot--select",
      label: "Organização",
      placeholder: "Selecione a organização que deseja filtrar",
      items: _vm.listOrganizations,
      option: "_id",
      "name-item": "name"
    },
    model: {
      value: _vm.filterOrganization,
      callback: function callback($$v) {
        _vm.filterOrganization = $$v;
      },
      expression: "filterOrganization"
    }
  }), _vm._v(" "), _c("app-select", {
    attrs: {
      "class-field": "mb-0 filter-slot filter-slot--select",
      label: "Unidade De Negócio",
      disabled: !_vm.filterOrganization || !_vm.listBusinessUnits.length,
      placeholder: "Selecione a Unidade que deseja filtrar",
      items: _vm.listBusinessUnits,
      option: "_id",
      "name-item": "name"
    },
    model: {
      value: _vm.filterBusiness,
      callback: function callback($$v) {
        _vm.filterBusiness = $$v;
      },
      expression: "filterBusiness"
    }
  })] : _vm._e()], 2)])]), _vm._v(" "), _vm.listItems.length ? _c("div", {
    staticClass: "content-list-table"
  }, [_c("div", [_c("p", [_vm._v("Total de " + _vm._s(_vm.total) + " itens. "), _c("a", {
    attrs: {
      href: "#"
    },
    on: {
      click: function click($event) {
        $event.preventDefault();
        return _vm.handlerUpdatePage.apply(null, arguments);
      }
    }
  }, [_vm._v("Atualize")]), _vm._v(" para ver novos dados.")])]), _vm._v(" "), _c("table-list-livenes-person", {
    attrs: {
      list: _vm.listClients,
      "action-open": _vm.openDetail
    }
  }), _vm._v(" "), _c("hr"), _vm._v(" "), _c("b-pagination", {
    attrs: {
      total: _vm.total,
      "per-page": _vm.limit,
      "aria-next-label": "Próxima página",
      "aria-previous-label": "Página anterior",
      "aria-page-label": "Página",
      "aria-current-label": "Página corrente"
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1) : _c("div", [_c("not-found")], 1)]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;